if (!customElements.get('product-testimonials')) {
  class ProductTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const sliderContainer = this.querySelector('.keen-slider');
      if (!sliderContainer) return;

      sliderContainer.classList.remove('slider-loading');
      this.slider = new KeenSlider(sliderContainer, {
        loop: false,
        slides: {
          perView: 1.2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 24,
            },
          },
          '(min-width: 1200px)': {
            slides: {
              perView: 3.2,
              spacing: 32,
            },
          },
        },
      });
    }
  }

  customElements.define('product-testimonials', ProductTestimonials);
}